import eventLogger from 'modules/Logger'
import * as Sip from 'redux/Sip'
import * as Contacts from 'redux/Contacts'
import * as Config from 'redux/Config'
import { AppThunk } from 'domains/redux'
import * as C from 'redux/Auth/constants'
import { ILoginData, ISipUAData } from 'domains/login'
import {
  clearContactsDb,
  getUserKeySyncToken,
  setUserKeySyncToken,
} from 'redux/Contacts/helpers'

type ErrorWithMessage = {
  message: string
}

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as Record<string, unknown>).message === 'string'
  )
}

function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
  if (isErrorWithMessage(maybeError)) return maybeError

  try {
    return new Error(JSON.stringify(maybeError))
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError))
  }
}

function getErrorMessage(error: unknown) {
  return toErrorWithMessage(error).message
}

const errorHandle = (e: Error) => {
  eventLogger.error('dialer', {
    name: e.name,
    message: getErrorMessage(e),
    stack: e.stack || '',
  })
}

const fetchAllData = (): AppThunk => (dispatch, getState) => {
  const {
    auth: { accountId, token, userId },
  } = getState()

  if (!(token && accountId && userId)) return

  // setup SIP user agent
  dispatch(Sip.fetchCredentials())
    .then((res: ISipUAData) => {
      dispatch(Config.hydrateUAConfig(res))

      dispatch(Sip.createConfig()).then(() => {
        dispatch(Sip.createUserAgent())
      })
    })
    .catch(errorHandle)

  getUserKeySyncToken().then((syncTokenUser) => {
    if (syncTokenUser !== String(userId)) {
      clearContactsDb().then(() => {
        dispatch(Config.fetchCNDInfo())
        dispatch(Contacts.fetchAllContacts())
      })
    } else {
      // CND info
      dispatch(Config.fetchCNDInfo())
      dispatch(Contacts.fetchAllContacts())
    }
    setUserKeySyncToken(String(userId))
  })
}

// TODO add userId into loginData
export const fetchInitData =
  (loginData: ILoginData): AppThunk =>
  (dispatch) => {
    dispatch({
      type: C.HYDRATE_UNITE_SUCCESS,
      payload: loginData,
    })

    Promise.all([
      dispatch(Config.fetchNotificationsPermission()),
      dispatch(fetchAllData()),
      dispatch(Config.fetchDebug()),
    ]).catch(errorHandle)
  }
